import { render, staticRenderFns } from "./SetupAccountProfile.vue?vue&type=template&id=c1a58306&scoped=true"
import script from "./SetupAccountProfile.vue?vue&type=script&lang=js"
export * from "./SetupAccountProfile.vue?vue&type=script&lang=js"
import style0 from "./SetupAccountProfile.vue?vue&type=style&index=0&id=c1a58306&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a58306",
  null
  
)

export default component.exports